<template>
  <div class="back">
    <crumb prevLevel="生产企业概况" current="药品生产概况" />
    <div class="form-contaner">
      <el-form label-width="105px" class="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="生产企业名称">
              <el-input
                placeholder="请输入生产企业名称"
                v-model="queryParams.compName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品通用名称">
              <el-input
                placeholder="请输入药品通用名称"
                v-model="queryParams.drugName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品批准文号">
              <el-input
                placeholder="请输入药品批准文号"
                v-model="queryParams.licenseNo"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产状态">
              <el-select v-model="queryParams.produceState">
                <el-option label="全部" value="" />
                <el-option label="停产" value="0" />
                <el-option label="在产" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属区域">
              <el-select v-model="queryParams.regRegionCityCode">
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.short_name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品性质">
              <el-select v-model="queryParams.productType">
                <el-option label="全部" value="" />
                <el-option label="化学药品" value="化学药品" />
                <el-option label="生物制品" value="生物制品" />
                <el-option label="中成药" value="中成药" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品分类">
              <el-select v-model="queryParams.isSpecial">
                <el-option label="全部" value="" />
                <el-option label="特药" value="1" />
                <el-option label="其它" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否OTC">
              <el-select v-model="queryParams.isPrescribed">
                <el-option label="全部" value="" />
                <el-option label="处方药" value="处方药" />
                <el-option label="非处方药" value="非处方药" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" @click="initQuery">查询</el-button>
    </div>
    <div class="statistic">
      <div class="body">
        <div class="num-statics">
          <div class="title">
            <p class="text">药品性质占比</p>
            <p class="sub-text">化学药品、中成药、生物制品</p>
          </div>
          <div class="num-list">
            <div
              class="num-item"
              v-for="item in numList1"
              :key="item.queryType"
            >
              <div class="num">{{ item.queryNum }}</div>
              <div class="text">{{ item.queryType }}</div>
            </div>
          </div>
          <Echarts :echartsOption="echartsOption1" echartsHeight="475px" />
        </div>
        <div class="scale-statics">
          <div class="title">
            <p class="text">药品分类占比</p>
            <p class="sub-text">特殊药品与其它药品</p>
          </div>
          <div class="num-list">
            <div
              class="num-item"
              v-for="item in numList2"
              :key="item.queryType"
            >
              <div class="num">{{ item.queryNum }}</div>
              <div class="text">{{ item.queryType }}</div>
            </div>
          </div>
          <Echarts :echartsOption="echartsOption2" echartsHeight="475px" />
        </div>
        <div class="num-statics">
          <div class="title">
            <p class="text">处方药占比</p>
            <p class="sub-text">处方药与非处方药</p>
          </div>
          <div class="num-list">
            <div
              class="num-item"
              v-for="item in numList3"
              :key="item.queryType"
            >
              <div class="num">{{ item.queryNum }}</div>
              <div class="text">{{ item.queryType }}</div>
            </div>
          </div>
          <Echarts :echartsOption="echartsOption3" echartsHeight="475px" />
        </div>
        <div class="scale-statics">
          <div class="title">
            <p class="text">药品生产状态占比</p>
            <p class="sub-text">在产与停产</p>
          </div>
          <div class="num-list">
            <div
              class="num-item"
              v-for="item in numList4"
              :key="item.queryType"
            >
              <div class="num">{{ item.queryNum }}</div>
              <div class="text">{{ item.queryType }}</div>
            </div>
          </div>
          <Echarts :echartsOption="echartsOption4" echartsHeight="475px" />
        </div>
        <div class="border"></div>
      </div>
    </div>
    <div class="drug-list">
      <div class="title">药品列表</div>
      <el-table :data="drugList" :cell-style="renderCell">
        <el-table-column label="药品通用名称" prop="drugName" width="150px" />
        <el-table-column
          label="药品批准文号"
          prop="licenseNo"
          width="160px"
          show-overflow-tooltip
        />
        <el-table-column label="剂型" prop="drugForm" />
        <el-table-column label="规格" prop="drugSpec" width="160px" />
        <el-table-column label="药品分类" prop="isSpecial" width="100px" />
        <el-table-column label="是否处方药" prop="isPrescribed" />
        <el-table-column label="生产企业名称" prop="compName" width="200px" />
        <el-table-column label="生产状态" prop="produceState" />
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        @current-change="loadDrugList"
        :page-size="5"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Crumb from 'components/crumb/crumb';
import Echarts from 'components/echarts/echarts';

const colors = [
  '#0B428A',
  '#975FE4',
  '#386CE2',
  '#FFB439',
  '#2BBF99',
  '#CEDBEF'
];

export default {
  data() {
    return {
      queryParams: {
        compName: '',
        drugName: '',
        licenseNo: '',
        produceState: '',
        regRegionCityCode: '',
        productType: '',
        isSpecial: '',
        isPrescribed: ''
      },
      numList1: [],
      echartsOption1: {
        gird: {
          containLabel: true
        },
        legend: {
          bottom: '30px',
          x: 'center',
          itemGap: 21,
          data: ['化学药品', '中成药', '生物制品'],
          itemWidth: 12,
          itemHeight: 12,
          icon: 'circle'
        },
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: [],
        series: [
          {
            name: '药品性质占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['40%', '55%'],
            data: [30, 20, 10],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '药品性质占比',
            type: 'pie',
            animation: false,
            center: ['50%', '45%'],
            radius: ['60%', '65%'],
            data: [30, 20, 10],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '药品性质占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '药品性质占比',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      numList2: [],
      echartsOption2: {
        gird: {
          containLabel: true
        },
        legend: {
          bottom: '30px',
          x: 'center',
          itemGap: 21,
          data: ['特殊药品', '其它'],
          itemWidth: 12,
          itemHeight: 12,
          icon: 'circle'
        },
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: [],
        series: [
          {
            name: '药品分类占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['40%', '55%'],
            data: [100, 200],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '药品分类占比',
            type: 'pie',
            animation: false,
            center: ['50%', '45%'],
            radius: ['60%', '65%'],
            data: [100, 200],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '药品分类占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '药品分类占比',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      numList3: [],
      echartsOption3: {
        gird: {
          containLabel: true
        },
        legend: {
          bottom: '30px',
          x: 'center',
          itemGap: 21,
          data: ['处方药', '非处方药'],
          itemWidth: 12,
          itemHeight: 12,
          icon: 'circle'
        },
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: [],
        series: [
          {
            name: '处方药占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['40%', '55%'],
            data: [200, 400],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '处方药占比',
            type: 'pie',
            animation: false,
            center: ['50%', '45%'],
            radius: ['60%', '65%'],
            data: [200, 400],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '处方药占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '处方药占比',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      numList4: [],
      echartsOption4: {
        gird: {
          containLabel: true
        },
        legend: {
          bottom: '30px',
          x: 'center',
          itemGap: 21,
          data: ['在产', '停产'],
          itemWidth: 12,
          itemHeight: 12,
          icon: 'circle'
        },
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: ['#0B428A', '#975FE4'],
        series: [
          {
            name: '药品生产状态占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['40%', '55%'],
            data: [100, 100],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '药品生产状态占比',
            type: 'pie',
            animation: false,
            center: ['50%', '45%'],
            radius: ['60%', '65%'],
            data: [100, 100],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '药品生产状态占比',
            type: 'pie',
            center: ['50%', '45%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '药品生产状态占比',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      drugList: [],
      total: 0,
      currentPage: 1,
      enterpriseId: ''
    };
  },
  computed: {
    ...mapState(['cityList'])
  },
  mounted() {
    const { cityCode } = this.$route.params;
    this.queryParams.regRegionCityCode = cityCode;
    this.initQuery();
  },
  methods: {
    initQuery() {
      this.loadEchartsData('1');
      this.loadEchartsData('2');
      this.loadEchartsData('3');
      this.loadEchartsData('4');
      this.loadDrugList();
    },
    loadEchartsData(pieChartType) {
      this.$request({
        url: 'rest/production/pieChartStatics',
        data: {
          json: JSON.stringify({
            params: {
              ...this.queryParams,
              pieChartType
            }
          })
        }
      }).then(res => {
        if (res.length === 1) {
          this[
            `echartsOption${pieChartType}`
          ].series[0].itemStyle.normal.borderWidth = 0;
          this[
            `echartsOption${pieChartType}`
          ].series[1].itemStyle.normal.borderWidth = 0;
        }
        this[`echartsOption${pieChartType}`].color = colors.slice(
          0,
          res.length
        );
        this[`echartsOption${pieChartType}`].legend.data = res.map(
          item => item.queryType
        );
        this[`echartsOption${pieChartType}`].series[0].data = res.map(item => ({
          name: item.queryType,
          value: item.queryNum
        }));
        this[`echartsOption${pieChartType}`].series[1].data = res.map(item => ({
          name: item.queryType,
          value: item.queryNum
        }));
        this[`numList${pieChartType}`] = res;
      });
    },
    loadDrugList(currentPage) {
      this.$request({
        url: 'rest/production/produceDrugList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 5
            },
            params: {
              ...this.queryParams
            }
          })
        }
      }).then(res => {
        this.drugList = res.list;
        this.total = res.total;
      });
    },
    renderCell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7) {
        if (row.produceState === '在产') {
          return { color: '#2BBF99' };
        } else {
          return { color: '#FF4C39' };
        }
      }
    }
  },
  components: {
    Crumb,
    Echarts
  }
};
</script>

<style lang="stylus" scoped>
.el-table
  font-size 12px
.back
  padding 0 20px 15px 20px
  border-radius 4px
  background #fff
  color #000
  .form-contaner
    position relative
    background #fff
    border-radius 8px
    padding 20px
    text-align center
  .statistic
    margin-top 20px
    padding 0 20px
    background #fff
    border-radius 8px
    overflow hidden
    color #000
    .body
      position relative
      overflow hidden
      border-bottom 1px solid #CEDBEF
      .num-statics
        position relative
        width 50%
        float left
        .echarts-border
          position absolute
          width 1px
          background rgba(206,219,239,.5)
          left 504px
          top 190px
          height 320px
      .scale-statics
        width 50%
        float left
        .title
          padding-left 30px
      .border
        width 1px
        position absolute
        top 0
        left 50%
        bottom 0
        background rgba(206,219,239,.5)
      .title
        border-bottom 1px solid #CEDBEF
        border-top 1px solid #CEDBEF
        padding 5px 0
        .text
          font-size 14px
          margin-bottom 5px
        .sub-text
          font-size 12px
          color #666666
      .num-list
        display flex
        justify-content center
        height 80px
        align-items center
        .num-item
          margin 0 20px
          text-align center
          .num
            color #386CE2
            font-size 28px
          .text
            font-size 12px
    .header
      color #000000
      border-bottom 1px solid #CEDBEF
      padding 20px 0
      span
        border-left 4px solid #386CE2
        padding-left 10px
  .drug-list
    padding 0 20px
    overflow hidden
    .title
      line-height 40px
      border-bottom 1px solid rgba(206,219,239, .5)
      margin-bottom 10px
      font-size 14px
      font-weight bold
  .pagination
    padding 20px
    float right
</style>
